import { CustomerRole } from "./AppLoad";

export enum CustomerType {
	NotSet = 0,
	Private = 1,
	Business = 2,
	SelfEmployed = 3
}

export interface LimitedCustomerToUpdate {
	// Lookup/id fields
	customerId?: number;
	customerNumber?: string;
	// Updateable fields
	phoneMobile?: string;
	email?: string;
}

export interface LimitedCustomer extends LimitedCustomerToUpdate {
	customerId: number;
	customerName?: string;
	customerTypeId?: CustomerType;
}

export interface ApplicationCustomerDetailsDTO extends LimitedCustomer {
	customerRole: CustomerRole;
	isMainCustomerSpouse?: boolean;
}
